<template>
  <div class="hot-recommend" v-if="recommend && recommend.length">
    <div class="title-common">
      <div class="title-common__text">{{ $t('热门搜索') }}：</div>
    </div>
    <div class="hot-text__content">
      <div
        class="hot-text finger-style"
        v-for="(item, idx) in recommend"
        :key="idx"
        @click="handleSelect(item.keyword)"
      >
        {{ item.keyword }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HotRecommend',
  props: {
    recommend: {
      type: Array,
      default: () => [], // success error
      required: false,
    },
  },
  methods: {
    handleSelect(item) {
      this.$trackEvent({
        eventId: 'sailing_c_x_search_hotword_ck',
        eventLabel: '搜索热词点击',
        attrs: {
          hot_word: item,
        },
      });
      this.$emit('handleSelect', 2, item);
    },
  },
};
</script>
<style lang="scss" src="./common.scss"></style>
